import { Injectable } from '@angular/core';
import { UrlService } from '@service/url/url.service';
import { RestService } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	
    CARGO_CHIEF = 'cargochief.com';

    constructor(
		private cargochief: Cargochief,
		private utilService: UtilService
	) {}

	isCargochiefUser() {
		if (!this.utilService.isNullOrUndefined(this.cargochief.getUser())) {
			const email = this.cargochief.getUser().email;
			return email.indexOf(this.CARGO_CHIEF) > -1;
		}
		return false;
	}
}
